export default {
    headers: {
        changePassword: {
            id: 'mobile.headers.changePassword'
        },
        diabetesDetails: {
            id: 'mobile.headers.diabetesDetails'
        },
        communicationPreferences: {
            id: 'mobile.headers.communicationPreferences'
        },
        deleteAccount: {
            id: 'mobile.headers.deleteAccount'
        },
        lastLogin: {
            id: 'mobile.headers.lastLogin'
        },
        personalDetails: {
            id: 'mobile.headers.personalDetails'
        },
        termsAndConditions: {
            id: 'mobile.headers.termsAndConditions'
        },
        privacyAndCookiesPolicy: {
            id: 'mobile.headers.privacyAndCookiesPolicy'
        },
        mfa: {
            id: 'mobile.headers.mfa'
        },
        openSourceLicenses: {
            id: 'mobile.headers.openSourceLicenses'
        },
        signOut: {
            id: 'mobile.headers.signOut'
        },
        noFile: {
            id: 'mobile.headers.noFile'
        },
        loading: {
            id: 'mobile.headers.loading'
        }
    },
    labels: {
        diabetesType: {
            id: 'mobile.labels.diabetesType'
        },
        treatmentType: {
            id: 'mobile.labels.treatmentType'
        }
    },
    placeholders: {
        loadingPhiSet: {
            id: 'mobile.placeholders.loadingPhiSet'
        }
    },
    infos: {
        unsavedChanges: {
            id: 'mobile.infos.unsavedChanges'
        },
        openSourceLicenses: {
            id: 'mobile.infos.openSourceLicenses'
        },
        signOut: {
            id: 'mobile.infos.signOut'
        }
    },
    intros: {
        deleteAccount: {
            id: 'mobile.intros.deleteAccount'
        },
        deleteAccountDesc: {
            id: 'mobile.intros.deleteAccountDesc'
        }
    },
    alerts: {
        changeCommunicationConsentsSuccess: {
            id: 'mobile.alerts.changeCommunicationConsentsSuccess'
        },
        changePasswordSuccess: {
            id: 'mobile.alerts.changePasswordSuccess'
        }
    },
    nav: {
        prev: {
            id: 'mobile.nav.prev'
        },
        next: {
            id: 'mobile.nav.next'
        }
    },
    licenses: {
        licenseHeader1: {
            id: 'mobile.licenses.licenseHeader1'
        },
        licenseHeader2: {
            id: 'mobile.licenses.licenseHeader2'
        },
        licenseHeader3: {
            id: 'mobile.licenses.licenseHeader3'
        },
        licenseHeader4: {
            id: 'mobile.licenses.licenseHeader4'
        },
        licenseHeader5: {
            id: 'mobile.licenses.licenseHeader5'
        }
    }
};
